<template lang="html">

<div class="floorList">

      <!-- 查看 -->
      <el-row class="seekLine">

         <el-col :span="6" class="inpItem">

              <div class="inpName">空间面积：</div>
              <div class="inpContent">
                <el-select @change="areaChange($event,'areaOptions1')" clearable size="medium" v-model="areaKey1" placeholder="请选择">
                    <el-option
                      v-for="item in areaOptions1"
                      :key="item.vak"
                      :label="item.name"
                      :value="item.val">
                    </el-option>
                  </el-select>
              </div>

         </el-col>

         <el-col :span="6" class="inpItem">

              <div class="inpName">空间报价：</div>
              <div class="inpContent">
                  <el-select @change="areaChange($event,'areaOptions2')" clearable size="medium" v-model="areaKey2" placeholder="请选择">
                      <el-option
                        v-for="item in areaOptions2"
                        :key="item.vak"
                        :label="item.name"
                        :value="item.val">
                      </el-option>
                    </el-select>
              </div>

         </el-col>

         <el-col :span="6" class="inpItem">

              <div class="inpName">租售状态：</div>
              <div class="inpContent">
                    <el-select @change="reList" size="medium" v-model="params.isSell" clearable placeholder="请选择">
                        <el-option
                          v-for="item in options"
                          :key="item.vak"
                          :label="item.name"
                          :value="item.val">
                        </el-option>
                      </el-select>
              </div>

         </el-col>

         <el-col :span="6" class="inpItem">

              <div class="inpName">装修情况：</div>
              <div class="inpContent">
                   <dic-select code="zxqk"
                        paramsKey="decoration"
                        :selectId="params.decorationId"
                        @selectChange="selectChange"
                        plaText="装修情况" />
              </div>

         </el-col>

         <el-col :span="6" class="inpItem">

              <div class="inpName">朝向：</div>
              <div class="inpContent">
                   <dic-select code="cx"
                        paramsKey="turnTowards"
                        :selectId="params.turnTowardsId"
                        @selectChange="selectChange"
                        plaText="朝向" />
              </div>

         </el-col>

         <el-col :span="6" class="inpItem">

              <div class="inpName">层高：</div>
              <div class="inpContent">
                  <el-select @change="areaChange($event,'areaOptions3')" clearable size="medium" v-model="areaKey3" placeholder="请选择">
                      <el-option
                        v-for="item in areaOptions3"
                        :key="item.vak"
                        :label="item.name"
                        :value="item.val">
                      </el-option>
                    </el-select>
              </div>

         </el-col>

         <el-col :span="6" class="inpItem">

              <div class="inpName">楼宇名称：</div>
              <div class="inpContent">
                   <el-input clearable @input="reList" v-model="params.buildingName" size="medium" placeholder="请输入内容" />
              </div>

         </el-col>

         <el-col :span="6" class="inpItem">

              <div class="inpName">所在街乡：</div>
              <div class="inpContent">
                   <tree-select code="szjx"
                        paramsKey="jiexiang"
                        :moreSelect="true"
                        :selectId="params.jiexiangId"
                        @selectChange="selectChange"
                        plaText="所在街乡" />
              </div>

         </el-col>

         <el-col :span="6" class="inpItem">

              <div class="inpName">定位：</div>
              <div class="inpContent">
                   <dic-select code="dw"
                        paramsKey="location"
                        :selectId="params.locationId"
                        @selectChange="selectChange"
                        plaText="定位" />
              </div>

         </el-col>

          <el-col :span="6" class="inpItem">

              <div class="inpName">所属功能区：</div>
              <div class="inpContent">
                   <dic-select code="ssgnyq"
                      paramsKey="park"
                      :selectId="params.parkId"
                      plaText="所属功能区"
                      @selectChange="selectChange" />
              </div>

         </el-col>

         <el-col :span="6" class="inpItem">

              <div class="inpName">当前空置可招商面积：</div>
              <div class="inpContent">
                  <el-select clearable @change="areaChange($event,'areaOptions4')" v-model="areaKey" size="medium" placeholder="请选择">
                     <el-option
                       v-for="item in areaOptions4"
                       :key="item.val"
                       :label="item.name"
                       :value="item.val">
                     </el-option>
                   </el-select>
              </div>

         </el-col>

         <el-col :span="6" class="inpItem">

              <div class="inpName">项目类型：</div>
              <div class="inpContent">
                    <dic-select code="xmlx"
                       paramsKey="projectType"
                       :selectId="params.projectTypeId"
                       plaText="项目类型"
                       @selectChange="selectChange" />
              </div>

         </el-col>

         <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6" class="inpItem">

              <div class="inpName"></div>
              <div class="inpContent">
                  <el-button @click="exCreate" style="width:80px;" size="small">导出</el-button>
                  <el-button @click="cleanSeek" style="width:80px;" size="small">重置</el-button>
              </div>

         </el-col>

      </el-row>

      <div class="pgContent">

           <el-table border
               v-loading="loading"
               header-cell-class-name="dHead"
               :data="tbData">

               <el-table-column fixed="left" align="center" width="60" label="序号">
                   <template slot-scope="scope">
                        {{ scope.$index + (listParams.no - 1)*listParams.size + 1 }}
                   </template>
               </el-table-column>
               <el-table-column prop="buildingName" fixed="left" align="center" min-width="150" label="楼宇名称" />
               <el-table-column prop="vacantArea" align="center" width="120" fixed="left" label="空置面积" />
               <el-table-column prop="jiexiang" align="center" width="90" label="所在街乡" />
               <el-table-column prop="controlFloor" align="center" width="90" fixed="left" label="空置楼层" />
               <el-table-column prop="decoration" align="center" width="90" label="装修情况" />
               <el-table-column prop="decorationInstructions" align="center" width="90" label="装修说明" />
               <el-table-column prop="actualUtilization" align="center" width="120" label="实际利用率">
                   <template slot-scope="scope">
                        {{ scope.row.actualUtilization }}%
                   </template>
               </el-table-column>
               <el-table-column prop="floorHeight" width="120" align="center" label="层高(米)"/>
               <el-table-column prop="turnTowards" width="120" align="center" label="朝向" />
               <el-table-column prop="paymentMethod" width="120" align="center" label="交付方式" />
               <el-table-column prop="price" width="180" align="center" label="报价(元/天/平方米)">
                   <template slot-scope="scope">
                        {{ scope.row | priceTrans(1) }}
                   </template>
               </el-table-column>
               <el-table-column prop="propertyCosts" width="180" align="center" label="物业费用(元/天/平方米)" />
               <el-table-column width="120" align="center" label="是否出售">
                  <template slot-scope="scope">
                     {{scope.row.isSell | strTrans}}
                  </template>
               </el-table-column>
               <el-table-column width="180" align="center" label="出售说明" >
                   <template slot-scope="scope">
                      {{scope.row | priceTrans(3)}}
                   </template>
               </el-table-column>
               <el-table-column width="180" align="center" label="最高售价">
                   <template slot-scope="scope">
                      {{scope.row | priceTrans(2)}}
                   </template>
               </el-table-column>

               <!-- <el-table-column prop="isSell" width="120" align="center" label="出售状态">
                   <template slot-scope="scope">
                        {{ scope.row.isSell | strTrans }}
                   </template>
               </el-table-column> -->

           </el-table>

           <div class="table-footer">

              <el-pagination
                class="paging"
                v-if="allPages>1"
                @current-change="currentChange"
                :current-page="listParams.no"
                :page-size="listParams.size"
                layout="total, prev, pager, next, jumper"
                :page-count="allPages"
                :total="listParams.allEls">
              </el-pagination>

          </div>



      </div>

      <div class="ECArea">
           <ECdomPre ref="ChildEx"></ECdomPre>
      </div>

</div>

</template>

<script>
import { getFloors } from '@/api/industryInfos';
import ECdomPre from './ECdomPre';
import { mapGetters } from 'vuex';

export default {
    filters:{
       strTrans(e){
           console.log(e);
           let arr = ['出售','出租']
           return arr[e-1];
       },
       priceTrans(row,type){
           if(type == 1){
                if(row.isSell == 2){
                   return row.price;
                }else{
                   return '-';
                }
           }else if(type == 2){
                if(row.isSell == 1){
                  return row.price + row.sellingPriceUtil;
                }else{
                  return '-';
                }
           }else if(type == 3){
                if(row.isSell == 1){
                   return row.sellingInstructions;
                }else{
                   return '-';
                   
                }
           }
       }
    },
    props:['type'],
    components:{
       ECdomPre
    },
    computed:{
      ...mapGetters(['userInfo'])
    },
    data(){
        return{
            tbData:[],

            options:[
              { name:'出售',val:1 },
              { name:'出租',val:2 },
            ],
            areaOptions1:[    //  空间面积
              { name:'100 ㎡以下', inarr:[0,100], val:1 },
              { name:'100-200 ㎡', inarr:[100,200], val:2 },
              { name:'200-300 ㎡', inarr:[200,300], val:3 },
              { name:'300-500 ㎡', inarr:[300,500], val:4 },
              { name:'500-1000 ㎡', inarr:[500,1000], val:5 },
              { name:'1000 ㎡以上', inarr:[1000,''], val:6 }
            ],
            areaOptions2:[    //  空间面积
              { name:'3 元以下', inarr:[0,3], val:1 },
              { name:'3-4 元',inarr:[3,4], val:2 },
              { name:'4-5 元',inarr:[4,5], val:3 },
              { name:'5-7 元',inarr:[5,7], val:4 },
              { name:'7-9 元',inarr:[7,9], val:5 },
              { name:'9-12 元',inarr:[9,12], val:6 },
              { name:'12 元以上',inarr:[12,''], val:7 }
            ],
            areaOptions3:[    //  层高
              { name:'3 米以下', inarr:[0,3], val:1 },
              { name:'3-4 米', inarr:[3,4],val:2 },
              { name:'4-5 米', inarr:[4,5],val:3 },
              { name:'5 米以上', inarr:[5,''],val:4 }
            ],
            areaOptions4:[    //  空间总面积
              { name:'1000 ㎡以下', inarr:[0,1000], val:1 },
              { name:'1000-3000 ㎡', inarr:[1000,2000], val:2 },
              { name:'3000-5000 ㎡', inarr:[3000,5000], val:3 },
              { name:'5000-10000 ㎡', inarr:[5000,10000], val:4 },
              { name:'10000-30000 ㎡', inarr:[10000,30000], val:5 },
              { name:'30000-50000 ㎡', inarr:[30000,50000], val:6 },
              { name:'50000 以上㎡', inarr:[50000,''], val:7 }
            ],
            areaKey:null,
            areaKey1:null,
            areaKey2:null,
            areaKey3:null,

            loading:false,


            params:{
                vacantArea1:'',
                vacantArea2:'',
                price1:'',
                price2:'',
                isSell:'',
                decorationId:'',
                turnTowardsId:'',

                buildingName:'',
                jiexiangId:'',
                locationId:'',
                parkId:'',
                totalVacantArea1:'',
                totalVacantArea2:'',
                floorHeight1:'',
                floorHeight2:'',
                orgId:''
            },

            allPages:0,
            listParams:{
                status:2,
                no:1,
                size:10,
                allEls:0
            }
        }
    },
    methods:{
        selectChange(e){
           this.params[e.paramsKey + 'Id'] = e.id;
           this.reList();
        },

        areaChange(e,key){
           let tempArr = this[key];
           if(key == 'areaOptions1'){
              if(e){
                this.params.vacantArea1 = tempArr[e-1].inarr[0];
                this.params.vacantArea2 = tempArr[e-1].inarr[1]
              }else{
                this.params.vacantArea1 = '';
                this.params.vacantArea2 = '';
              }
     
                this.areaKey1=e;
           
           }else if(key == 'areaOptions2'){
              if(e){
                this.params.price1 = tempArr[e-1].inarr[0];
                this.params.price2 = tempArr[e-1].inarr[1]
              }else{
                this.params.price1 = '';
                this.params.price2 = '';
              }
      
                this.areaKey2=e;
            
           }else if(key == 'areaOptions3'){
              if(e){
                this.params.floorHeight1 = tempArr[e-1].inarr[0];
                this.params.floorHeight2 = tempArr[e-1].inarr[1]
              }else{
                this.params.floorHeight1 = '';
                this.params.floorHeight2 = '';
              }
            
                this.areaKey3=e;
           }else if(key == 'areaOptions4'){
              if(e){
                this.params.totalVacantArea1 = tempArr[e-1].inarr[0];
                this.params.totalVacantArea2 = tempArr[e-1].inarr[1]
              }else{
                this.params.totalVacantArea1 = '';
                this.params.totalVacantArea2 = '';
              }
              this.areaKey=e;
           }
           
           console.log(this.params);
           this.reList();
        },

        cleanSeek(){
           for(let key in this.params){
               this.params[key] = '';
           }
           this.areaKey=null;
            this.areaKey1=null;
            this.areaKey2=null;
            this.areaKey3=null;
           this.reList();
        },

        currentChange(e){
           this.listParams.no = e;
           this.getList();
        },

        getList(){
            if(this.type==2){
                this.params.orgId=this.userInfo.orgId;
            }
            this.loading = true;
            getFloors(Object.assign({},this.params,this.listParams)).then(res => {
                this.loading = false;
                this.tbData = res.industrialSpaceFloorWhereList;
                this.listParams.allEls = res.totalElements;
                this.allPages = res.totalPages;
            })
        },

        reList:function(){
            
            this.params.no = 1;
            this.getList();
        },

        exCreate:function(){
            if(this.listParams.allEls > 0){
                let newPms = Object.assign({},this.params,this.listParams);
                this.$refs.ChildEx.metIDAsk(newPms,2);
            }else{
                this.$message.error('当前无数据可导出！');
            }
        },

        goInner(type){
            //  type 1 新建 2 编辑 3 查看
            if(type == 1){
                 this.$router.push({
                     path:'bulidingEdit',
                     query:{
                         type
                     }
                 });
            }
        }

    },
    created(){
      console.log(this.type);
       this.getList();
    }
}
</script>

<style lang="scss" scoped>

.floorList{
    font-size: 15px;

    .headLine{
        padding: 0 20px;
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #EBEEF5;
    }
    .navLine{
       padding-left: 20px;
       border-bottom: 1px solid #EBEEF5;
       .navItem{
           height: 54px;
           font-size: 14px;
           margin-left: 30px;
           display: inline-block;
           line-height: 54px;
           border-bottom: 2px solid white;
           cursor: pointer;
           &.act{
              color: #409EFF;
              border-color: #409EFF;
           }
       }
    }
    .seekLine{
        padding: 20px;
        padding-bottom: 0px;
        border-bottom: 1px solid #EBEEF5;
        .inpItem{
            padding-right: 20px;
            margin-bottom: 20px;
            .inpName{
                width: 120px;
                float: left;
                font-size: 14px;
                text-align: right;
                padding-top: 6px;
            }
            .inpContent{
                margin-left: 120px;
                .el-select{
                    display: block;
                }
            }
        }

    }

    .btnLine{
        padding: 20px;
        padding-bottom: 0px;
    }

    .ECArea{
        display: none;
    }

    .pgContent{
         padding: 20px;


        .table-footer{
            margin-top: 20px;
            text-align: right;
        }

        .ibtn{
            cursor: pointer;
            font-size: 13px;
            margin: 0 3px;
        }

        .ibtn:nth-child(1){
            color: #409EFF;
        }
        .ibtn:nth-child(2){
            color: #E6A23C;
        }
        .ibtn:nth-child(3){
            color: #F56C6C;
        }
    }

}

</style>

<style lang="scss">

#buildings{
    .el-input__inner{
        border-radius: 0px;
    }
    .dHead{
        background: #f5f5f5;
        font-weight: normal;
    }

}

</style>



// WEBPACK FOOTER //
// floorList.vue?3db4dd50